module.exports = __webpack_public_path__ + "img/product-6.872d3214.png";